import { useSelector } from "react-redux";

export default function usePermission() {
  const userType = useSelector((state: any) => state.site.siteInfo?.userType);
  return userType;
}

export const useIsAdministrator = () => {
  const permission = usePermission();
  return permission !== "普通用户";
};
